import React, { Fragment, useEffect, useState } from "react";
import { Row, CardBody, Card, Button, ButtonGroup, CustomInput, Input } from "reactstrap";
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { Separator, Colxx } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Languages from '../../../../../data/languages';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
    API_OpenAI_Assistant,
    gAPI_QuestionSets,

} from '../../../../../constants/APIs';

function Features({ botSettings, saveIntegration, integration, integrationProperties, locale, allProperties }) {
    const [formatedProperties, setFormatedProperties] = useState([]);
    const [features, setFeatures] = useState(botSettings.features);
    const [languageGPT3, setLanguageGPT3] = useState([]);
    const [assistantList, setAssistantList] = useState([])
    const [aiAssistant, setAIAssistant] = useState(features.openAIAssistant?.assistantId ? features.openAIAssistant?.assistantId : '')
    const [selectedProperty, setSelectedProperty] = useState(integrationProperties.length > 0 ? integrationProperties[0] : '');

    useEffect(() => {
        const result = integrationProperties.map(id => {
            return allProperties.find(elem => elem.id === id);
        });
        setFormatedProperties(result);

    }, [integrationProperties, allProperties]);

    const handleChange = (event) => {
        setSelectedProperty(event.target.value);

    };

    useEffect(() => {
        const languageList = Languages.map((elem) => {
            elem.checked = false;
            botSettings.features.languageGPT3.forEach((lang) => {
                if (lang === elem.code) {
                    elem.checked = true;
                }
            });
            return elem;
        });

        setLanguageGPT3(languageList);
    }, [botSettings]);

    useEffect(() => {
        if (selectedProperty) {
            loadResponse();
        }
    }, [selectedProperty]);

    const handleCheckedSerach = (e) => {
        var feat = { ...features };
        feat.predictiveSearch = e;
        setFeatures(feat);
        botSettings.features = feat;
        setTimeout(() => {
            NotificationManager.success(
                '',
                e === true ? 'Predictive search enabled successfully' : 'Predictive search disabled successfully',
                3000,
                null,
                null,
                'success'
            );
        }, 100);
        saveIntegration({ botSetting: botSettings });
    };
    const handleCheckedUpsells = (e) => {
        var feat = { ...features };
        feat.addOnUpsells = e;
        setFeatures(feat);
        botSettings.features = feat;
        setTimeout(() => {
            NotificationManager.success(
                '',
                e === true ? 'Add-on`s & upsells enabled successfully' : 'Add-on`s & upsells disabled successfully',
                3000,
                null,
                null,
                'success'
            );
        }, 100);
        saveIntegration({ botSetting: botSettings });
    };
    const handleAutoLanguageDetection = (e) => {
        var feat = { ...features };
        feat.autoLanguageDetection = e;
        setFeatures(feat);
        botSettings.features = feat;
        setTimeout(() => {
            NotificationManager.success(
                '',
                e === true ? 'Auto language detection enabled successfully' : 'Auto language detection disabled successfully',
                3000,
                null,
                null,
                'success'
            );
        }, 100);
        saveIntegration({ botSetting: botSettings });
    };


    // openAI

    const loadResponse = async () => {
        return await AxiosAPI({
            methed: 'get',
            url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${locale}`,
        })
            .then(res => {

                var setslist = res.data.sets.sort((a, b) => a.displayOrder - b.displayOrder)
                var list = [];
                if (setslist !== null && setslist.length > 0) {
                    setslist
                        .filter(l => l.type === 'DynamicConversationFlow' && l.openAiAssistantId !== "")
                        .map(l => {
                            list.push({ id: l.openAiAssistantId, name: l.name });
                        });

                }

                setAssistantList(list);


            })
            .catch(err => {
                console.error('API error:', err.response ? err.response.data : err.message);
            });
    };
    //e.o.OpenAI

    const handleCheckedOpenAIEnabled = (e) => {

        var feat = { ...features };
        feat.fixedResponses = e === true ? false : true;
        feat.generativeGPT3 = false;
        var openai = { ...feat.openAIAssistant };
        openai.isEnabled = e;
        feat.openAIAssistant = openai;
        setFeatures(feat);
    };
    const handleChangeAssistantId = (e) => {
        setAIAssistant(e.target.value);
        var feat = { ...features };
        var openai = { ...feat.openAIAssistant };
        openai.assistantId = e.target.value;
        feat.openAIAssistant = openai;
        setFeatures(feat);
    };

    const handleVersionDynamicFlowChange = (e) => {
        var feat = { ...features };
        var openai = { ...feat.openAIAssistant };
        openai.versionDynamicFlow = e;
        feat.openAIAssistant = openai;
        setFeatures(feat);
    }

    const handleCheckedFixedResponses = (e) => {
        var feat = { ...features };
        feat.generativeGPT3 = e === true ? false : true;
        feat.fixedResponses = e;
        var openai = { ...feat.openAIAssistant };
        openai.isEnabled = false;
        feat.openAIAssistant = openai;
        setFeatures(feat);
        botSettings.features = feat;
        setTimeout(() => {
            NotificationManager.success(
                '',
                e === true ? 'Fixed Responses enabled successfully' : 'Fixed Responses disabled successfully',
                3000,
                null,
                null,
                'success'
            );
        }, 100);
        saveIntegration({ botSetting: botSettings });
    };
    const handleCheckedGenerativeGTP3 = (e) => {
        var feat = { ...features };
        feat.fixedResponses = e === true ? false : true;
        feat.generativeGPT3 = e;
        var openai = { ...feat.openAIAssistant };
        openai.isEnabled = false;
        feat.openAIAssistant = openai;
        setFeatures(feat);
        botSettings.features = feat;
        setTimeout(() => {
            NotificationManager.success(
                '',
                e === true ? 'Generative GTP3 enabled successfully' : 'Generative GTP3 disabled successfully',
                3000,
                null,
                null,
                'success'
            );
        }, 100);
        saveIntegration({ botSetting: botSettings });
    };
    const handleCheckedGenerativeChatGTP = (e) => {
        var feat = { ...features };
        feat.generativeChatGPT = e;
        setFeatures(feat);
        botSettings.features = feat;
        setTimeout(() => {
            NotificationManager.success(
                '',
                e === true ? 'Generative ChatGTP enabled successfully' : 'Generative ChatGTP disabled successfully',
                3000,
                null,
                null,
                'success'
            );
        }, 100);
        saveIntegration({ botSetting: botSettings });
    };
    const handleLanguageChange = (e) => {
        const values = languageGPT3.map((elem) => {
            if (elem.code === e.target.value) {
                elem.checked = !elem.checked;
            }
            return {
                ...elem,
            };
        });
        setLanguageGPT3(values);
        const langArr = values.filter((elem) => elem.checked === true).map((elem) => elem.code);
        setFeatures({ ...features, languageGPT3: langArr });
    };
    const handleVersionGPT3Change = (e) => {
        var feat = { ...features };
        feat.versionGPT3 = e;
        setFeatures(feat);
    }
    const handleSave = () => {
        botSettings.features = features;

        saveIntegration({ botSetting: botSettings });
    };

    const handleCheckedPreTrained = (e) => {
        var feat = { ...features };
        var intent = { ...feat.intentRecognition };
        intent.isPreTrainedIndustry = e;
        intent.isStaticConversationFlow = e === true ? false : true;
        feat.intentRecognition = intent;
        setFeatures(feat);
        botSettings.features = feat;
        saveIntegration({ botSetting: botSettings });
    };

    const handleCheckedStaticFlow = (e) => {
        var feat = { ...features };
        var intent = { ...feat.intentRecognition };
        intent.isPreTrainedIndustry = e === true ? false : true;
        intent.isStaticConversationFlow = e;
        feat.intentRecognition = intent;
        setFeatures(feat);
        botSettings.features = feat;
        saveIntegration({ botSetting: botSettings });
    };

    const handleChangeStaticAssistantId = (e) => {
        var feat = { ...features };
        var intent = { ...feat.intentRecognition };
        intent.assistantId = e.target.value;
        feat.intentRecognition = intent;
        setFeatures(feat);
    };

    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <div className="text-center mb-2">
                        <h6>Features</h6>
                    </div>
                    {integration === undefined && <Separator className="mb-3" />}
                    {integration === undefined && <div className="row mt-1 ml-2 mb-1">
                        <div className="d-flex w-100">
                            <h5 style={{ marginTop: '0.15rem' }}>Predictive search</h5>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.predictiveSearch}
                                name='predictiveSearch'
                                onChange={(e) => handleCheckedSerach(e)}
                            />
                        </div>
                        <div className="row " style={{ marginLeft: '0.5rem' }}>
                            <p className="m-2">When enabled, user will see predictive suggestions as they type the message</p>
                        </div>
                    </div>}
                    {integration === undefined && <Separator className="mb-3" />}
                    {integration === undefined && <div className="row mt-1 ml-2 mb-1">
                        <div className="d-flex w-100">
                            <h5 style={{ marginTop: '0.15rem' }}>Add-on's & upsells</h5>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.addOnUpsells}
                                name='enabled'
                                onChange={(e) => handleCheckedUpsells(e)}
                            />
                        </div>
                        <div className="row " style={{ marginLeft: '0.5rem' }}>
                            <p className="m-2">When enabled, guests will be shown the Add-on and upsell options available</p>
                        </div>
                    </div>}
                    <Separator className="mb-3" />
                    <div className="row mt-1 ml-2 mb-1">
                        <div className="d-flex w-100">
                            <h5 style={{ marginTop: '0.15rem' }}>Auto language detection</h5>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.autoLanguageDetection}
                                name='enabled'
                                onChange={(e) => handleAutoLanguageDetection(e)}
                            />
                        </div>
                        <div className="row " style={{ marginLeft: '0', marginRight: '1rem' }}>
                            <p className="m-2">When enabled, the language will be auto detected based on the first two messages guest sends. Rest of the conversation will be in that language.</p>
                        </div>
                    </div>
                    <Separator className="mb-3" />
                    <div className="ml-2">
                        <h5 style={{ marginTop: '0.15rem' }}>Choose your NLP </h5>
                        <div className="d-flex ml-2 mt-2">
                            <h7 style={{ marginTop: '0.15rem' }}>Fixed Responses</h7>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.fixedResponses}
                                name='fixedResponses'
                                onChange={(e) => handleCheckedFixedResponses(e)}
                            />
                        </div>
                        <div className="d-flex ml-2 mt-2">
                            <h7 style={{ marginTop: '0.15rem' }}>Gen AI</h7>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.generativeGPT3}
                                name='generativeGPT3'
                                onChange={(e) => handleCheckedGenerativeGTP3(e)}
                            />
                        </div>
                        <div className="d-flex ml-2 mb-2 mt-2">
                            <h7 style={{ marginTop: '0.15rem', marginBottom: '4px' }}>Dynamic Conversation Flow</h7>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.openAIAssistant.isEnabled}
                                name='openAIisEnabled'
                                onChange={(e) => handleCheckedOpenAIEnabled(e)}
                            />
                        </div>
                        <div className="d-none">
                            <h5 style={{ marginTop: '0.15rem' }}>Generative ChatGPT</h5>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.generativeChatGPT}
                                name='generativeChatGPT'
                                onChange={(e) => handleCheckedGenerativeChatGTP(e)}
                            />
                        </div>
                    </div>

                    {features.openAIAssistant.isEnabled === true && formatedProperties !== null && (
                        <Fragment>
                            <Separator className="mb-3 mt-2" />
                            {formatedProperties.length > 1 &&
                                <div className="mb-1 ml-2 ">
                                    <h6 >Properties</h6>


                                    <Input
                                        className="border p-2 mb-3"
                                        type={formatedProperties.length > 1 ? "select" : "text"}
                                        name="Property Id"
                                        value={formatedProperties.length > 1 ? selectedProperty : `${formatedProperties[0].name} (${formatedProperties[0].id})`}
                                        onChange={formatedProperties.length > 1 ? handleChange : undefined}
                                    >
                                        {formatedProperties.length > 1 ? (
                                            formatedProperties.map((list, index) => (
                                                <option key={index} value={list.id}>
                                                    {`${list.name} (${list.id})`}
                                                </option>
                                            ))
                                        ) : (
                                            <>{`${formatedProperties[0].name} (${formatedProperties[0].id})`}</>
                                        )}
                                    </Input>

                                </div>
                            }
                        </Fragment>
                    )}
                    {assistantList && assistantList !== null && features.openAIAssistant.isEnabled === true &&
                        <Fragment>
                            {/* <Separator className="mb-3" /> */}
                            <div className="mb-1 ml-2 ">
                                <h6 >Dynamic Conversation Flow</h6>


                                {/* <Input
                                    type="text"
                                    name="assistantId"
                                    onChange={handleChangeAssistantId}
                                    placeholder="Assistant Id"
                                    value={assistantList.map(assist => `${assist.name} (${assist.id})`).join(', ')}
                                // defaultValue={features.openAIAssistant.assistantId}
                                /> */}
                                {assistantList.length > 0 ? (
                                    <Input className="border p-2 mb-3"
                                        type="select"
                                        name="assistantId"
                                        placeholder="Dynamic Conversation Flow"
                                        value={aiAssistant}
                                        onChange={handleChangeAssistantId}
                                    >
                                        <option value="" disabled>Select a Dynamic Conversation Flow</option>
                                        {assistantList.map((assist, index) => (
                                            <option key={index} value={assist.id}>
                                                {`${assist.name} (${assist.id})`}
                                            </option>
                                        ))}
                                    </Input>
                                ) : (
                                    <Input
                                        className="border p-2 mb-3"
                                        type="text"
                                        name="assistantId"
                                        onChange={handleChangeAssistantId}
                                        placeholder="Dynamic Conversation Flow"
                                        defaultValue={aiAssistant}

                                    />
                                )}
                                <Input
                                    type="select"
                                    name="versionDynamicFlow"
                                    value={features.openAIAssistant.versionDynamicFlow}
                                    onChange={(e) => handleVersionDynamicFlowChange(e.target.value)}
                                >
                                    <option value="">Select</option>
                                    <option value="6DynamicConverstionFlow">Version 6 (with Dynamic Conversation Flow)</option>
                                </Input>
                            </div>
                        </Fragment>
                    }
                    {features.generativeGPT3 && (
                        <Fragment>
                            <Separator className="mb-3" />
                            <div className="mb-1 ml-2 text-center">
                                <b>Select Version</b>
                                <br />
                                <Input
                                    type="select"
                                    name="version"
                                    value={features.versionGPT3}
                                    onChange={(e) => handleVersionGPT3Change(e.target.value)}
                                >
                                    <option value="1">Version 1 (Retired)</option>
                                    <option value="2">Version 2 (Retired)</option>
                                    <option value="3">Version 3</option>
                                    <option value="5">Version 5 </option>
                                    <option value="6">Version 6</option>
                                </Input>
                            </div>
                            <div className="mb-1 ml-2 text-center">
                                <b>Choose Languages</b>
                                <br />
                                <Row className="mt-2">
                                    {languageGPT3.map((elem, index) => (
                                        <Colxx xxs="4">
                                            {' '}
                                            <CustomInput
                                                key={index}
                                                type="checkbox"
                                                value={elem.code}
                                                id={elem.code}
                                                onChange={handleLanguageChange}
                                                checked={elem.checked}
                                                className="text-left"
                                            >
                                                {elem.name}
                                            </CustomInput>
                                        </Colxx>
                                    ))}
                                </Row>
                            </div>
                        </Fragment>
                    )}
                    <Separator className="mb-3" />
                    <div className="ml-2">
                        <h5 style={{ marginTop: '0.15rem' }}>Choose Intent Recognition Method</h5>
                        <div className="d-flex ml-2 mt-2">
                            <h7 style={{ marginTop: '0.15rem' }}>Pre-Trained Industry Method</h7>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.intentRecognition ? features.intentRecognition.isPreTrainedIndustry : true}
                                name='isPreTrainedIndustry'
                                onChange={(e) => handleCheckedPreTrained(e)}
                            />
                        </div>
                        <div className="d-flex ml-2 mt-2">
                            <h7 style={{ marginTop: '0.15rem' }}>Based on Static Conversation Flows</h7>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={features.intentRecognition ? features.intentRecognition.isStaticConversationFlow : true}
                                name='isStaticConversationFlow'
                                onChange={(e) => handleCheckedStaticFlow(e)}
                            />
                        </div>
                        {features.intentRecognition.isStaticConversationFlow &&
                            <div className="d-flex ml-2 mt-2">
                                <Input
                                    className="border p-2 mb-3"
                                    type="text"
                                    name="assistantId"
                                    onChange={handleChangeStaticAssistantId}
                                    placeholder="Assistant Id"
                                    defaultValue={features.intentRecognition.assistantId}
                                />
                            </div>
                        }
                    </div>
                    <Separator className="mb-3 mt-5" />
                    <div className="text-center">
                        <ButtonGroup className="mb-2 mt-2">
                            <Button color="primary" size="xs" outline onClick={handleSave}>
                                Save
                            </Button>
                        </ButtonGroup>
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );

}


export default Features;